module.exports = __webpack_public_path__ + "images/live-show-tip-4f14d06d25.png";